import { render } from "./Monsters.vue?vue&type=template&id=5072c29d&scoped=true"
import script from "./Monsters.vue?vue&type=script&lang=js"
export * from "./Monsters.vue?vue&type=script&lang=js"

import "./Monsters.vue?vue&type=style&index=0&id=5072c29d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5072c29d"]])

export default __exports__